import React from "react"
import { Box, Link, InternalIcon, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { CarrotPlansPaths } from "#/utils/Paths"
import { Link as RouterLink } from "react-router-dom"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import { useGetInProgressCarrotPlanRequestType } from "#/components/carrot-plans/hooks/useGetInProgressCarrotPlanRequestType"
import { ThanksForUpdatingUsTile } from "#/components/home/carrot-plan/ThanksForUpdatingUsTile"
import { CarrotPlan } from "#/types/carrotPlanTypes"
import { CheckInExperienceCta } from "#/components/carrot-plans/check-in/CheckInExperienceCta"
import { BorderedInfoBox } from "#/components/shared/BorderedInfoBox"
import { isPlanOlderThan7Days } from "#/components/carrot-plans/shared/calculateIsPlanOlderThan7Days"

type CarrotPlanFooterProps = {
  plan: CarrotPlan
}

export function CarrotPlanFooter({ plan }: CarrotPlanFooterProps): JSX.Element | null {
  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const inProgressCarrotPlanRequestType = useGetInProgressCarrotPlanRequestType()

  const allStepsCompleted = plan?.steps.every((step) => step.completedAtUtc)
  const isPlanOnTheWay = cpRequestStatusQuery.data?.carrotPlanIsOnTheWay
  const isRequestInProgress = inProgressCarrotPlanRequestType.data != null
  const isPlanCompleteOrStale = allStepsCompleted || plan.isStale

  if (isPlanOnTheWay) {
    return <ThanksForUpdatingUsTile />
  }
  if (isRequestInProgress) {
    return <ContinueInProgressUpdateTile />
  }
  if (!isPlanCompleteOrStale && isPlanOlderThan7Days(plan.createdAtUtc)) {
    return <CheckInUpdateTile />
  }

  return null
}

function CheckInUpdateTile(): JSX.Element {
  return (
    <BorderedInfoBox>
      <CheckInExperienceCta />
    </BorderedInfoBox>
  )
}

function ContinueInProgressUpdateTile(): JSX.Element {
  return (
    <BorderedInfoBox>
      <Box
        display="flex"
        flexDirection="column"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
        alignItems="start"
      >
        <Typography>
          <FormattedMessage defaultMessage="Continue sharing your update to receive new suggestions for next steps." />
        </Typography>
        <Link
          to={CarrotPlansPaths.REDIRECT}
          component={RouterLink}
          endIcon={<InternalIcon fontSize="small" color="primary" />}
        >
          <FormattedMessage defaultMessage="Continue" />
        </Link>
      </Box>
    </BorderedInfoBox>
  )
}
